module.exports = __webpack_public_path__ + "img/0x5F88AB06e8dfe89DF127B2430Bba4Af600866035.b831a65c.png";